<template>
    <div class="Group-CurrencyExchangeRate">

    </div>
</template>

<script>
export default {
  name: 'Group-CurrencyExchangeRate',
  data () {
    return {
      options: [],
      value: ''
    }
  },
  methods: {
    updates (item) {
    },
    submit() {
      return {}
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
.Group-CurrencyExchangeRate {
    width: 100%;
}
</style>
